'use client';

import { useEffect, type Dispatch, type SetStateAction } from 'react';

import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { Modal, ModalButton, BaseModalContent } from '@/components/modal';
import { ANALYTICS_EVENTS, RESIDENTIAL_SERVICE_PHONE_NO } from '@/constants';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

type OutsideServiceAreaModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  onCancel?: () => void;
};

export const OutsideServiceAreaModal = ({
  isModalOpen = false,
  setIsModalOpen,
}: OutsideServiceAreaModalProps) => {
  const description = `Currently we only service VIC, NSW, SA and South East QLD. If you are in one of these areas please call us for plans and pricing.`;

  const { resetJoinFormStore } = useJoinFormStore();

  function closeModal() {
    resetJoinFormStore();
    setIsModalOpen(false);
    trackAnalyticsEvent(ANALYTICS_EVENTS.outsideOfServiceAreaModal.modalClose, {})
  }

  function openModal() {
    setIsModalOpen(true);
  }

  useEffect(() => {
    if (isModalOpen) {
      trackAnalyticsEvent(ANALYTICS_EVENTS.outsideOfServiceAreaModal.modalOpen, {});
    }
  }, [isModalOpen]);

  return (
    <Modal
      heading="Outside of service area"
      description={description}
      isModalOpen={isModalOpen}
      openModal={openModal}
      closeModal={closeModal}
    >
      <BaseModalContent
        buttonComponent={
          <ModalButton
            variant="primary"
            href={`tel:${RESIDENTIAL_SERVICE_PHONE_NO}`}
            onClick={() => trackAnalyticsEvent(ANALYTICS_EVENTS.outsideOfServiceAreaModal.call, {})}
          >
            Call {RESIDENTIAL_SERVICE_PHONE_NO}
          </ModalButton>
        }
      />
    </Modal>
  );
};
